import {FormikProps} from 'formik';
import {ChangeEvent} from 'react';
import LikeInputOutlet from '../../../../components/IlikeIputOutlet';
import TabbedDescriptionTextareaUseForm from '../../../../components/TabbedDescriptionTextarea/TabbedDescriptionTextareaUseForm';
import {IProductForm} from './productFormData';

interface IProps {
  form: FormikProps<IProductForm>;
}

const TitleDescription = ({form}: IProps) => {
  return (
    <div className="space-y-5">
      {/* -------------------------------- Advertsiement Title -------------------------------- */}

      <section>
        <p className="mb-2 color-gray-1 text-md">عنوان آگهی</p>

        <LikeInputOutlet
          name="title"
          label=""
          value={form?.values.title || ''}
          placeholder="عنوان آگهی"
          touched={!!form?.values.title}
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            form?.setFieldValue('title', e.target.value);
          }}
        />
      </section>

      {/* ----------------------------- Advertsiement Description ----------------------------- */}

      <section>
        <TabbedDescriptionTextareaUseForm form={form} />
      </section>
    </div>
  );
};

export default TitleDescription;
